import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "profile-history" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Transaction = _resolveComponent("Transaction")!
  const _component_HistoryTable = _resolveComponent("HistoryTable")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_HistoryTable, {
          key: 0,
          class: "history-wrap",
          header: [
				_ctx.t('Profile.operation'),
				'',
				_ctx.t('Profile.sum'),
				'',
				_ctx.t('Profile.method'),
				'',
				_ctx.t('Profile.bonus'),
				'',
				_ctx.t('Profile.date')
			],
          columns: ['', '', '', '', '', '', ''],
          count: _ctx.transactions.length
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (tx) => {
              return (_openBlock(), _createBlock(_component_Transaction, {
                class: "item-wrap",
                key: `${tx.type}-${tx.id}`,
                id: tx.id,
                type: tx.type,
                amount: tx.amountUsd,
                bonusAmount: tx.bonusAmountUsd,
                bonusPercent: tx.bonusPercent,
                method: tx.method,
                item: tx.item,
                date: new Date(tx.updatedAt)
              }, null, 8, ["id", "type", "amount", "bonusAmount", "bonusPercent", "method", "item", "date"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["header", "count"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 1,
          width: "64px",
          height: "64px",
          class: "spinner-wrap"
        }))
      : _createCommentVNode("", true)
  ]))
}